export default __webpack_public_path__ + "static/media/list.1b2c225b.svg";